import moment from 'moment-timezone';
import { AUTH_TOKEN, COUNTRY_OPTION_PK, COUNTRY_OPTION_US, WDIC_ALERT } from "../constants";

/**
 * getToken is a function that retrieves the authentication token from the local storage.
 *
 * @function
 * @returns {string | null} The authentication token if found in the local storage, or null if not found.
 */
export const getToken = () => localStorage.getItem(AUTH_TOKEN);

export const firstLetterUppercase = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const centToDollar = (value: number) => value / 100;

export const formatPhoneNumber = (phoneNumber: string) => {
  // if (phoneNumber.startsWith('1')) {
  //   return `+1 (${phoneNumber.slice(1, 4)}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7)}`;
  // }
  // else if (phoneNumber.startsWith('+1')) {
  //   return `+1 (${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(5, 8)}-${phoneNumber.slice(8)}`;
  // }
  // else if (phoneNumber.startsWith('92')) {
  //   return `(+92) ${phoneNumber.slice(2, 5)} ${phoneNumber.slice(5)}`;

  // }
  // else if (phoneNumber.startsWith('+92')) {
  //   return `+92 ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
  // }
  if (phoneNumber.startsWith('1')) {
    return `+1 ${phoneNumber.slice(1, 4)} ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7)}`;
  }
  else if (phoneNumber.startsWith('+1')) {
    return `+1 ${phoneNumber.slice(2, 5)} ${phoneNumber.slice(5, 8)}-${phoneNumber.slice(8)}`;
  }
  else if (phoneNumber.startsWith('92')) {
    return `+92 ${phoneNumber.slice(2, 5)} ${phoneNumber.slice(5)}`;

  }
  else if (phoneNumber.startsWith('+92')) {
    return `+92 ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
  }

  return phoneNumber;
};

/**
 * Formats a Unix timestamp into MM/DD/YYYY format.
 * @param {number} timestamp - The Unix timestamp to format.
 * @returns {string} The formatted date in MM/DD/YYYY format.
 */
export const formatDate = (timestamp: number): string => {
  const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear());

  return `${month}/${day}/${year}`;
}

export const humanize = (string: string) => {
  if (string === 'subscription_create') return 'Subscription Created';
  if (string === 'subscription_update') return 'Subscription Updated';
  const fragments = string.split('_');
  for (let i = 0; i < fragments.length; i++) {
    fragments[i] = fragments[i].charAt(0).toUpperCase() + fragments[i].slice(1);
  }
  return fragments.join(' ');
}

export const convert_US_TO_USA = (country: string) => {
  if (country === 'US') return COUNTRY_OPTION_US.label;
  if (country === 'PK') return COUNTRY_OPTION_PK.label;
  return '';
}

export const formatNewDate = (date: string) => moment(date).format('MMM DD, YYYY');

/**
 * Capitalizes the first word of a given string.
 * @param {string} inputString - The input string to capitalize.
 * @returns {string} The input string with the first word capitalized.
 */
export const capitalizeFirstWord = (inputString: string): string => {
  if (inputString.length === 0) {
    return inputString; // Return empty string if input is empty
  }

  const firstChar = inputString.charAt(0).toUpperCase(); // Get the first character and capitalize it
  const restOfString = inputString.slice(1); // Get the rest of the string

  return firstChar + restOfString;
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

export const getAlertDismiss = () => {
  return localStorage.getItem(WDIC_ALERT);
};

export const setAlertDismiss = () => {
  return localStorage.setItem(WDIC_ALERT, "true");
};